import React, { useEffect, useState } from "react";
import ViewOfficialInformationStyles from "./ViewOfficialInformation.styles";
import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import { getOfficeDetails } from "../StepperServices";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import { useAppSelector } from "../../../../../utils/hooks";
import { selectUserId } from "../../../../../redux/authSlice";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
}

const ViewOfficialInformation = (props: CustomProps) => {
  const userIdFromRedux = useAppSelector(selectUserId);
  const [offialDetailState, setOffialDetailState] = useState<any>([]);
  const [apiResponse, setApiResponse] = useState(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setApiResponse(true);
      const response = await getOfficeDetails(userIdFromRedux);
      customErrorHandler(response);
      setOffialDetailState(response?.data);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const classes = ViewOfficialInformationStyles;
  return (
    <>
      <Box sx={classes.contentWrapper}>
        <Box sx={classes.pageInfoHeader}>
          <Typography sx={classes.Heading}>Official Information</Typography>
          <Typography sx={classes.text}>
            Update your offcial information for the platform
          </Typography>
        </Box>
        <Grid container>
          <Box sx={classes.profileDetails}>
            <Grid container rowSpacing={3}>
              <Grid item xs={12}>
                <Typography sx={classes.detailsHeading}>
                  Official Details
                </Typography>
                <Typography sx={classes.subHeading}>
                  Manage your official information to use the platform
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Employee Type</Typography>
                <Typography sx={classes.userDetails}>
                  {offialDetailState?.emp_type}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Department</Typography>
                <Typography sx={classes.userDetails}>
                  {offialDetailState?.department}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Designation</Typography>
                <Typography sx={classes.userDetails}>
                  {offialDetailState?.designation}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Account Number</Typography>
                <Typography sx={classes.userDetails}>1362473375</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Joining Date</Typography>
                <Typography sx={classes.userDetails}>
                  {offialDetailState?.joining}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography sx={classes.userLabal}>Working Days</Typography>
                <Box sx={classes.workingContainer}>
                  <Typography sx={classes.userDetails}>
                    {offialDetailState?.working_days}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Working Shift</Typography>
                <Typography sx={classes.userDetails}>
                  {offialDetailState?.working_shift}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Grid item xs={4}>
            <Box sx={classes.buttonWarapper}>
              <CustomButton
                label="Back"
                buttonType="secondaryBtn"
                onClick={() => {
                  props.backStep?.();
                }}
              />
              <CustomButton
                label="Next"
                buttonType="primaryBtn"
                onClick={() => {
                  props.nextStep?.();
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      {apiResponse && <CustomLoader apiResponse={false} />}
    </>
  );
};

export default ViewOfficialInformation;
